// @ts-check
import { Trans } from '@lingui/macro';
import { useHistory } from 'react-router-dom';
import Footer, {
  BackButton,
  CancelButton,
  NextButton,
} from '../../../../components/Layout/Footer';
import Layout from '../../../../components/Layout/Layout';
import Main from '../../../../components/Layout/Main';
import {
  PageHeader,
  PageSubtitle,
  PageTitle,
} from '../../../../components/Layout/PageHeader';
import MapIdFields, {
  useIdentifierFields,
} from '../../../../components/MapFields/MapIdFields';
import useImportFlow from '../useImportFlow';
import {
  newProductsFieldsToImport,
  ProgressIndicator,
  useLink,
} from './_config';
import { filterFieldsToImport } from './helper';

export default function IdentifyNewProductsFields({ match }) {
  const { workspaceId, importId } = match.params;
  const { identifierFields } = useIdentifierFields({
    workspaceId,
    importId,
    fieldsToImport: newProductsFieldsToImport,
  });
  const { isProducer, loading } = useImportFlow();

  if (loading) return null;

  if (isProducer) {
    return (
      <ProducerNewProductFields
        match={match}
        identifierFields={identifierFields}
      />
    );
  }
  return (
    <NonProducerNewProductFields
      match={match}
      identifierFields={identifierFields}
    />
  );
}

function ProducerNewProductFields({ match, identifierFields }) {
  const link = useLink('identifyNewProductsFields');
  const history = useHistory();
  const fieldsToImport = newProductsFieldsToImport.filter(
    ({ key }) => key !== 'producer.name'
  );

  const props = useIdentifierFields({
    workspaceId: match.params.workspaceId,
    importId: match.params.importId,
    fieldsToImport: filterFieldsToImport({ identifierFields, fieldsToImport }),
  });
  // const props = {
  //   ..._props,
  //   fieldsToImport: filterFieldsToImport(_props),
  // };
  // console.log(props);

  return (
    <Layout>
      <ProgressIndicator step="identifyFields" />
      <PageHeader>
        <PageTitle>
          <Trans>Identify your products</Trans>
        </PageTitle>
        <PageSubtitle>
          <Trans>Indicate the column that contains short product name.</Trans>
        </PageSubtitle>
      </PageHeader>
      <Main>
        <MapIdFields
          {...props}
          fieldsToImport={props.fieldsToImport?.filter(
            ({ key }) =>
              key !== 'product.instanceId' &&
              key !== 'product.productExternalId'
          )}
        />
      </Main>
      <Footer>
        <BackButton to={link.back()} />
        <CancelButton to={link.cancel()} />
        <NextButton
          onClick={async () => {
            const result = await props.updateIdentifierMapping();
            if (!result?.error) history.push(link.next());
          }}
          disabled={!props.isValid}
        />
      </Footer>
    </Layout>
  );
}

function NonProducerNewProductFields({ match, identifierFields }) {
  const link = useLink('identifyNewProductsFields');
  const history = useHistory();
  const props = useIdentifierFields({
    workspaceId: match.params.workspaceId,
    importId: match.params.importId,
    fieldsToImport: filterFieldsToImport({
      identifierFields,
      fieldsToImport: newProductsFieldsToImport,
    }),
  });

  // const props = {
  //   ..._props,
  //   fieldsToImport: filterFieldsToImport(_props),
  // };

  return (
    <Layout>
      <ProgressIndicator step="identifyFields" />
      <PageHeader>
        <PageTitle>
          <Trans>Indicate basic Product and Producer columns</Trans>
        </PageTitle>
        <PageSubtitle>
          <Trans>
            Indicate the column that contains short product name and producer
            name.
          </Trans>
        </PageSubtitle>
      </PageHeader>
      <Main>
        <MapIdFields
          {...props}
          fieldsToImport={props.fieldsToImport?.filter(
            ({ key }) =>
              key !== 'product.instanceId' &&
              key !== 'product.productExternalId'
          )}
        />
      </Main>
      <Footer>
        <BackButton to={link.back()} />
        <CancelButton to={link.cancel()} />
        <NextButton
          onClick={async () => {
            const result = await props.updateIdentifierMapping();
            if (!result?.error) history.push(link.next());
          }}
          disabled={!props.isValid}
        />
      </Footer>
    </Layout>
  );
}
